// Local LLM row for a PLATFORM-HOSTED model (managed in Model Serving).
// One live status — the same one Model Serving shows — drives both the Health and
// the Status parts, so the two pages can't disagree (staging 2026-10-08: Local LLM
// said "Unreachable"/"Off" while Model Serving said "Parked"). The model is changed
// in Model Serving; here it's read-only apart from Enable / Disable. The row is
// laid out by the responsive list (table / compact / cards — localLlmLayout).
import { Badge as UiBadge, IconButton } from "../../components/ui";
import { COLORS } from "../../theme/colors";
import { useEndpointServingStatus, ServingLightState } from "./ModelServingLight";
import { servingState } from "./modelServingModel";
import { Badge, Btn } from "./modelServingUi";
import { EndpointLayout } from "./localLlmLayout";

/** Open this model in Admin → Model Serving (its drawer opens on arrival). */
export function openInModelServing(key) {
  window.history.replaceState(null, "", `/admin?tab=model_serving&model=${encodeURIComponent(key)}`);
  window.dispatchEvent(new CustomEvent("admin:goto-tab", { detail: { id: "model_serving" } }));
}

export default function HostedEndpointCells({ row, layout = "table", onToggle }) {
  const { status, error } = useEndpointServingStatus(row.endpoint_id);
  const state = error ? "unreachable" : status ? servingState(status) : null;
  const health = (
    <span data-testid="hosted-health">
      {state ? <Badge status={state} /> : <span style={{ color: COLORS.textDim }}>…</span>}
    </span>
  );
  const statusPart = (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 6 }}>
      <UiBadge color={row.enabled ? "#10B981" : COLORS.muted}>{row.enabled ? "Enabled" : "Disabled"}</UiBadge>
      <ServingLightState status={status} error={error} compact />
    </div>
  );
  const actions = (
    <div style={{ display: "inline-flex", flexWrap: "wrap", justifyContent: "flex-end", gap: 6, alignItems: "center" }}>
      <Btn sm data-testid="manage-in-model-serving" title="Status, settings, versions and removal live in Model Serving"
        onClick={() => openInModelServing(row.endpoint_id)}>Manage in Model Serving</Btn>
      <IconButton icon={row.enabled ? "🚫" : "✅"} title={row.enabled ? "Disable" : "Enable"} onClick={onToggle} />
    </div>
  );
  return <EndpointLayout row={row} layout={layout} parts={{ health, status: statusPart, actions }} />;
}
